/**
 * Where Stripe returns a merchant after they finish bank setup.
 *
 * Public on purpose: the merchant is not a Homecrowd user and has no session.
 * They arrived from an emailed link, so there is nowhere to send them next —
 * the page closes the loop and stops there rather than offering a sign-in they
 * cannot use.
 *
 * The wording has to hold for both paths Checkout offers. Linking a bank
 * instantly activates the mandate; typing account numbers starts microdeposit
 * verification that takes a few days and needs the merchant to come back. We
 * cannot tell which happened without the session, so this says what is true of
 * both and lets Stripe's own email carry the specifics.
 */

const page = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '24px',
  backgroundColor: '#f9fafb',
  fontFamily: '"Baikal Book", -apple-system, BlinkMacSystemFont, sans-serif',
};

const card = {
  width: '100%',
  maxWidth: '520px',
  backgroundColor: 'white',
  border: '1px solid #e5e7eb',
  borderRadius: '12px',
  padding: '40px',
  textAlign: 'center',
};

const MerchantBankLinked = () => (
  <div style={page}>
    <div style={card}>
      <div
        style={{
          width: '56px',
          height: '56px',
          margin: '0 auto 24px',
          borderRadius: '50%',
          backgroundColor: '#dcfce7',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M4 12.5l5 5L20 6.5"
            stroke="#16a34a"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <h1 style={{ fontSize: '22px', fontWeight: 600, color: '#111827', margin: '0 0 12px' }}>
        Thanks — we've got your authorization
      </h1>

      <p style={{ fontSize: '15px', lineHeight: 1.6, color: '#4b5563', margin: '0 0 20px' }}>
        Your bank details have been sent securely to Stripe, our payment processor.
        Homecrowd never sees or stores your account number.
      </p>

      <div
        style={{
          textAlign: 'left',
          backgroundColor: '#f9fafb',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          padding: '16px 18px',
          fontSize: '14px',
          lineHeight: 1.6,
          color: '#4b5563',
          margin: '0 0 24px',
        }}
      >
        <strong style={{ color: '#111827' }}>What happens next</strong>
        <p style={{ margin: '8px 0 0' }}>
          Stripe is emailing you a confirmation of the authorization you just gave.
        </p>
        <p style={{ margin: '8px 0 0' }}>
          If you typed your account and routing numbers rather than signing in to your
          bank, Stripe will send two small deposits to verify the account. They arrive
          in a couple of business days, and you'll get an email asking you to confirm
          the amounts before anything is finalized.
        </p>
      </div>

      <p style={{ fontSize: '13px', color: '#6b7280', margin: 0 }}>
        You can close this window. Questions? Email{' '}
        <a href="mailto:support@gethomecrowd.com" style={{ color: '#0369a1' }}>
          support@gethomecrowd.com
        </a>
        .
      </p>
    </div>
  </div>
);

export default MerchantBankLinked;
